export const actionTypes = {
  GET_POS_DECENTRALIZED: "GET_POS_DECENTRALIZED",
  SET_POS_DECENTRALIZED: "SET_POS_DECENTRALIZED",
  GET_POS_DECENTRALIZED_BY_ID: "GET_POS_DECENTRALIZED_BY_ID",
  SET_POS_DECENTRALIZED_BY_ID: "SET_POS_DECENTRALIZED_BY_ID",
  GET_DECENTRALIZED_FILTERED_RESULTS: "GET_DECENTRALIZED_FILTERED_RESULTS",
  SET_DECENTRALIZED_FILTERED_RESULTS: "SET_DECENTRALIZED_FILTERED_RESULTS",
  EDIT_CHILD_POS_FORM_CHANGE: "EDIT_CHILD_POS_FORM_CHANGE",
  ADD_CHILD_POS: "ADD_CHILD_POS",
  UPDATE_CHILD_POS: "UPDATE_CHILD_POS",
};

export const actions = {
  getPosDecentralized: (payload) => ({
    type: actionTypes.GET_POS_DECENTRALIZED,
    payload: payload,
  }),

  setPosDecentralized: (payload) => ({
    type: actionTypes.SET_POS_DECENTRALIZED,
    payload: payload,
  }),

  getPosDecentralizedById: (payload) => ({
    type: actionTypes.GET_POS_DECENTRALIZED_BY_ID,
    payload: payload,
  }),

  setPosDecentralizedById: (payload) => ({
    type: actionTypes.SET_POS_DECENTRALIZED_BY_ID,
    payload: payload,
  }),

  getDecentralizedFilteredResults: (payload) => ({
    type: actionTypes.GET_DECENTRALIZED_FILTERED_RESULTS,
    payload: payload,
  }),

  setDecentralizedFilteredResults: (payload) => ({
    type: actionTypes.SET_DECENTRALIZED_FILTERED_RESULTS,
    payload: payload,
  }),

  addChildPos: (payload) => ({
    type: actionTypes.ADD_CHILD_POS,
    payload: payload,
  }),

  updateChildPos: (payload) => ({
    type: actionTypes.UPDATE_CHILD_POS,
    payload: payload,
  }),

  setChilsPosEditForm: (payload) => ({
    type: actionTypes.EDIT_CHILD_POS_FORM_CHANGE,
    payload: payload,
  }),
};
